<div class="feature-item">
    <h3 class="feature-title">{{ feature?.title }}</h3>
    <p class="feature-description">{{ feature?.description }}</p>

    @if (feature?.images?.length) {
    <div class="feature-images">
        @for (image of feature.images; track image) {
        <div class="feature-image-container" [ngClass]="{ 'single-image': feature.images?.length === 1 }">
            <img [src]="image?.url" alt="Feature Image" class="feature-image" />
        </div>
        }
    </div>
    }
</div>